const confirmar_transferencia_escola_origem = {
  path: "/confirmar-transferencia-escola-origem",
  redirect: "/confirmar-transferencia-escola-origem",
  meta: {
    breadCrumb: "Processo de Matrículas - Confirmar a Transferência do Aluno",
  },
  children: [
    {
      path: "/confirmar-transferencia-escola-origem",
      name: "confirmar-transferencia-escola-origem",
      component: () =>
        import(
          "@/views/ConfirmarTransferenciaEscolaOrigem/ConfirmarTransferenciaEscolaOrigem.vue"
        ),
    },
  ],
};

export { confirmar_transferencia_escola_origem };
